 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		11: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"f13eac9a5768d45c5e278caabb46102c92ba707b","1":"4f4042ba323d6f392592c7d46453789a0b96ccf6","2":"styles","3":"141f109e6862ccef4947ca435eb5258ad2b0769e","4":"4380d918493bfd2fe50cdeb760cca753f3916e9a","5":"a4c92b5b","6":"e72b5256bf4205658ef2ff4c6d6c96ed6fdf9296","7":"c06a0cd996c66bd84402140d20fe142e114c9a4e","8":"c1dcaf347079c47bccdc10c1be120605aa7ef23a","9":"f2e9dd1b8bd9399a29431b9b14387bfd8491d2b4","10":"f68520c5b8e2a3055b87c984fb9973b9621a1a77","13":"component---src-pages-404-js","14":"component---src-pages-about-us-en-js","15":"component---src-pages-about-us-js","16":"component---src-pages-business-ai-en-js","17":"component---src-pages-business-ai-js","18":"component---src-pages-business-bems-en-js","19":"component---src-pages-business-bems-js","20":"component---src-pages-business-elevator-en-js","21":"component---src-pages-business-elevator-js","22":"component---src-pages-business-escalator-en-js","23":"component---src-pages-business-escalator-js","24":"component---src-pages-business-hvac-en-js","25":"component---src-pages-business-hvac-js","26":"component---src-pages-business-logistics-en-js","27":"component---src-pages-business-logistics-js","28":"component---src-pages-business-parking-tower-en-js","29":"component---src-pages-business-parking-tower-js","30":"component---src-pages-business-si-en-js","31":"component---src-pages-business-si-js","32":"component---src-pages-contact-en-js","33":"component---src-pages-contact-js","34":"component---src-pages-elsa-en-js","35":"component---src-pages-elsa-js","36":"component---src-pages-en-js","37":"component---src-pages-index-js","38":"component---src-pages-modal-modal-js","39":"component---src-pages-press-en-js","40":"component---src-pages-press-js","41":"component---src-pages-robot-en-js","42":"component---src-pages-robot-js","43":"component---src-pages-standard-group-stand-en-js","44":"component---src-pages-standard-group-stand-js","45":"component---src-pages-standard-inter-stand-en-js","46":"component---src-pages-standard-inter-stand-js","47":"component---src-pages-standard-inter-stand-y-4420-en-js","48":"component---src-pages-standard-inter-stand-y-4420-js","49":"component---src-pages-standard-nation-stand-en-js","50":"component---src-pages-standard-nation-stand-js","51":"component---src-pages-standard-tta-stand-en-js","52":"component---src-pages-standard-tta-stand-js","53":"component---src-templates-news-post-js"}[chunkId]||chunkId) + "-" + {"0":"310483541ef64bc4044c","1":"b8201a74c1aacd116ca7","2":"f3e9059f8c2a75df70f2","3":"2d766934284235958b79","4":"8337358abd9c6970f831","5":"8236ad545eb20203c870","6":"34f087d7174ba677b168","7":"7a09fc2b0e96be29a1b5","8":"8b8c55980ec4f9efdc5d","9":"a9bcacb06c5b553a8460","10":"4518693ee6aff6659e9d","13":"e0abe52580a63c0f56f4","14":"90ab62ab6533dfb23ef1","15":"05c801281aed9e9911ea","16":"8e5a23960d9c3eede8f9","17":"6b2c67b9565563cf0bc2","18":"017934d14f4cc8068d41","19":"58212d7176f699febcc7","20":"1550ded19d0f4122e4aa","21":"a8f87e7658ef593c9286","22":"e6f7d36b08e58761b680","23":"0bd95597c67539573d14","24":"9db20ef203ecc7562b19","25":"372d7e154d5c0b84f8a8","26":"f9516842d3bbc6e5524e","27":"ac01bc9106a128e0a102","28":"e9a02140eed013d992f0","29":"099dfda587917f7c6981","30":"eb7fd9e7d6f465d42017","31":"f4c0772e77020169ee37","32":"9d635132dd5f2c7c5485","33":"542afb408dbb781b86e2","34":"932cd4247a9581b1d6f0","35":"b9898b6dea65c5c3d7f6","36":"8e0bd0e4f87a6251e926","37":"cf71d6d3fc8bdbee4024","38":"a4740af10ba7d7b2c14f","39":"f823be487b950658435d","40":"890cfe7df54b062f00dc","41":"762b7751c9963e690cb6","42":"52fc9767b5457c655e83","43":"aa7ca8122117ad8949f2","44":"3c54fc884de07aa2127b","45":"d96692dd0ec4159509ab","46":"6daef5dd12ac37052d3b","47":"b201fd4c2a88c776d5ab","48":"89f4b17ae98f9d013f03","49":"2669dfa1a23d046c065d","50":"6b88edaf1821c0db79fd","51":"2e1acbb98bf7ca248503","52":"a30748d2113acfad2b83","53":"83aeeb20059f6ecbce93"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"f13eac9a5768d45c5e278caabb46102c92ba707b","1":"4f4042ba323d6f392592c7d46453789a0b96ccf6","2":"styles","3":"141f109e6862ccef4947ca435eb5258ad2b0769e","4":"4380d918493bfd2fe50cdeb760cca753f3916e9a","5":"a4c92b5b","6":"e72b5256bf4205658ef2ff4c6d6c96ed6fdf9296","7":"c06a0cd996c66bd84402140d20fe142e114c9a4e","8":"c1dcaf347079c47bccdc10c1be120605aa7ef23a","9":"f2e9dd1b8bd9399a29431b9b14387bfd8491d2b4","10":"f68520c5b8e2a3055b87c984fb9973b9621a1a77","13":"component---src-pages-404-js","14":"component---src-pages-about-us-en-js","15":"component---src-pages-about-us-js","16":"component---src-pages-business-ai-en-js","17":"component---src-pages-business-ai-js","18":"component---src-pages-business-bems-en-js","19":"component---src-pages-business-bems-js","20":"component---src-pages-business-elevator-en-js","21":"component---src-pages-business-elevator-js","22":"component---src-pages-business-escalator-en-js","23":"component---src-pages-business-escalator-js","24":"component---src-pages-business-hvac-en-js","25":"component---src-pages-business-hvac-js","26":"component---src-pages-business-logistics-en-js","27":"component---src-pages-business-logistics-js","28":"component---src-pages-business-parking-tower-en-js","29":"component---src-pages-business-parking-tower-js","30":"component---src-pages-business-si-en-js","31":"component---src-pages-business-si-js","32":"component---src-pages-contact-en-js","33":"component---src-pages-contact-js","34":"component---src-pages-elsa-en-js","35":"component---src-pages-elsa-js","36":"component---src-pages-en-js","37":"component---src-pages-index-js","38":"component---src-pages-modal-modal-js","39":"component---src-pages-press-en-js","40":"component---src-pages-press-js","41":"component---src-pages-robot-en-js","42":"component---src-pages-robot-js","43":"component---src-pages-standard-group-stand-en-js","44":"component---src-pages-standard-group-stand-js","45":"component---src-pages-standard-inter-stand-en-js","46":"component---src-pages-standard-inter-stand-js","47":"component---src-pages-standard-inter-stand-y-4420-en-js","48":"component---src-pages-standard-inter-stand-y-4420-js","49":"component---src-pages-standard-nation-stand-en-js","50":"component---src-pages-standard-nation-stand-js","51":"component---src-pages-standard-tta-stand-en-js","52":"component---src-pages-standard-tta-stand-js","53":"component---src-templates-news-post-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"86c73cc3ef22f26a623b","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
